<template>
  <el-footer height="auto">
    <div class="footer container">
      <div class="middle">
        <div class="middle-con">
          <p class="title">{{ $t('ppst.p61') }}</p>
          <p><img src="/ppst/static/img/ppst/bottom_notice_dot.png" /><span>{{ $t('ppst.p62') }}</span></p>
          <p><img src="/ppst/static/img/ppst/bottom_notice_dot.png" /><span>{{ $t('ppst.p63') }}</span></p>
          <p><img src="/ppst/static/img/ppst/bottom_notice_dot.png" /><span>{{ $t('ppst.p64') }}</span></p>
          <p><img src="/ppst/static/img/ppst/bottom_notice_dot.png" /><span>{{ $t('ppst.p65') }}</span></p>
          <p><img src="/ppst/static/img/ppst/bottom_notice_dot.png" /><span>{{ $t('ppst.p66') }}</span></p>
          <p><img src="/ppst/static/img/ppst/bottom_notice_dot.png" /><span>{{ $t('ppst.p67') }}</span></p>
          <p><img src="/ppst/static/img/ppst/bottom_notice_dot.png" /><span>{{ $t('ppst.p68') }}</span></p>
          <p><img src="/ppst/static/img/ppst/bottom_notice_dot.png" /><span>{{ $t('ppst.p69') }}</span>
            <a v-if="lang === 'en'" href="https://bit.ly/3fyIyie" target="_blank">https://bit.ly/3fyIyie</a>
            <a v-if="lang === 'pt'" href="https://bit.ly/2W5vnh0" target="_blank">https://bit.ly/2W5vnh0</a>
          </p>
          <p><img src="/ppst/static/img/ppst/bottom_notice_dot.png" /><span>{{ $t('ppst.p70') }}</span></p>
        </div>
        <div class="middle_url">
          <p>{{ $t('ppwcHome.p7') }}</p>
          <a v-if="lang === 'en'" href="https://bit.ly/3fyIyie" target="_blank">{{ $t('ppst.p71') }}</a>
          <a v-if="lang === 'pt'" href="https://bit.ly/2W5vnh0" target="_blank">{{ $t('ppst.p71') }}</a>
          <br />
          <br />
          <br />
          <p>{{ $t('ppwcHome.p9') }}</p>
          <a target="_blank" href="#/user-agreement-ppwc">{{ $t('ppwcHome.p10') }}</a>
          <br />
          <a target="_blank" href="#/privacy-policy-ppwc">{{ $t('ppwcHome.p11') }}</a>
        </div>
        <div class="submit">
          <img class="logo" src="/ppst/static/img/ppst/bottom_logo.png" />
        </div>
      </div>

      <!-- <el-divider></el-divider>

      <div class="copyright">
        <p>{{ $t('ppwcHome.p13') }}</p>

      </div> -->
    </div>

  </el-footer>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    return {
      lang: this.$route.params.lang || 'en',
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-footer {
  position: relative;
  font-size: 14px;
  color: #fff;
  // background: url("/official/static/img/home/bg_03.png") center top;
  // background-repeat: no-repeat;
  background-color: #000;
  // margin-top: -74px;
  a {
    box-shadow: 0 1PX;
  }
  .footer {
    position: relative;
    // height: 300px;
    padding: 100px 10px;
    .el-divider--horizontal {
      margin: 30px 0px;
      background-color: #252525;
      // opacity: 0.37;
    }
    .middle {
      position: relative;
      padding: 0px 0px 60px 0px;
      min-height: 300px;
      .middle-con {
        width: 700px;
        color: #ffffff;
        .title {
          font-size: 18px;
          color: #ffffff;
          opacity: 1;
          margin-bottom: 16px;
          margin-top: 8px;
        }
        p {
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 10px;
          padding-left: 20px;
          span {
            font-size: 14px;
            line-height: 20px;
            opacity: 0.6;
          }
          img {
            display: inline-block;
            margin-right: 6px;
            margin-top: 7px;
            width: 5px;
            vertical-align: top;
            margin-left: -11px;
          }
        }
        a {
          opacity: 0.6;
          font-size: 14px;
          &:hover {
            color: #00ffa8;
          }
        }
      }
      .middle_url {
        position: absolute;
        right: 0px;
        top: 0px;
        display: inline-block;
        margin-right: 10px;
        a {
          font-size: 14px;
          margin: 8px 0px;
          display: inline-block;
          color: #fffff;
          opacity: 0.6;
          &:hover {
            color: #00ffa8;
          }
        }
        p {
          font-size: 18px;
          margin: 8px 0px;
        }
      }
      .submit {
        position: absolute;
        display: inline-block;
        bottom: 0px;
        right: 10px;
        .logo {
          width: 160px;
        }
        .el-input {
          width: 280px;
          // margin-right: 3px;
          vertical-align: middle;
          /deep/.el-input__inner {
            color: #797979;
            background-image: url(/official/static/img/home/submit_bg_01.jpg);
            background-repeat: repeat;
            border: none;
            border-radius: 0px;
          }
        }
        .el-button {
          vertical-align: middle;
          border-radius: 0px;
          color: #383838;
          background-image: url(/official/static/img/home/submit_bg_02.jpg);
          background-repeat: repeat;
          font-size: 16px;
          height: 40px;
          padding: 12px 14px;
          border: none;
          // &:active {
          // }
        }
      }
    }
    .copyright {
      position: relative;
      // padding-top: 110px;
      p {
        display: inline-block;
        color: #898989;
        font-size: 12px;
      }
      .logo {
        float: right;
      }
    }
  }
}
</style>
